import { render, staticRenderFns } from "./MyUtil.vue?vue&type=template&id=01084c56&scoped=true&"
import script from "./MyUtil.vue?vue&type=script&lang=js&"
export * from "./MyUtil.vue?vue&type=script&lang=js&"
import style0 from "./MyUtil.vue?vue&type=style&index=0&id=01084c56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01084c56",
  null
  
)

export default component.exports